module.exports = __webpack_public_path__ + "media/wyposazenie/audio@2x-1f51d556.png";